import React, { useContext, useMemo, useReducer } from 'react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import { sportsStandingsHandlers, sportsStandingsInitialState, sportsStandingsReducer } from '../../cnr/reducers/SportsStandingsReducer'
import { CreatePlayoffContext } from '../../create/CreatePlayoff'
import LevelSectionStandings from './LevelSectionStandings'
import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders'

export const _standingsTypes = {
  section: 'section',
  team: 'team',
  match: 'match',
  playoff: 'playoff'
}

export const SportsStandingsContext = React.createContext()

const LeagueStandings = (props) => {

  const {
    standingType,
    forOverview,
    forPlayoff,
    playoffLevel
  } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { favorites_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { appUserFavs } = favorites_state ?? {}
  const _teamKey_page = pathViews?.teams
  const _matchKey_page = pathViews?.matches
  const _teamsFavs = appUserFavs && appUserFavs['teams']

  useRenders('SportsStandingsContext', true);

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state } = createPlayoffContext ?? {}
  const { playoff_info } = createPlayoff_state ?? {}
  const { oppsOnly } = playoff_info ?? {}

  let _standingType = standingType;

  if (_teamKey_page) {
    _standingType = _standingsTypes.team
  } else if (_matchKey_page) {
    _standingType = _standingsTypes.match
  }

  const init_state = {}
  const [sportsStandings_state, sportsStandings_dispatch] = useReducer(sportsStandingsReducer, init_state, sportsStandingsInitialState)
  const sportsStandings_handlers = useMemo(
    () => sportsStandingsHandlers(sportsStandings_dispatch),
    [sportsStandings_dispatch]
  );

  const {
    noData,
    selectedLevelKey,
    selectedTeamLevel,
    selectedTeams,
    selectedTeamSection,
    showPlayoffPicture,
  } = sportsStandings_state ?? {}

  // wrap with SportsStandingsContext
  return <SportsStandingsContext.Provider value={{ sportsStandings_state, sportsStandings_handlers }}>
    <LevelSectionStandings
      _matchKey_page={_matchKey_page}
      _standingType={_standingType}
      _teamKey_page={_teamKey_page}
      _teamsFavs={_teamsFavs}
      forOverview={forOverview}
      forPlayoff={forPlayoff}
      playoffLevel={playoffLevel}
      noData={noData}
      oppsOnly={oppsOnly}
      selectedLevelKey={selectedLevelKey}
      selectedTeamLevel={selectedTeamLevel}
      selectedTeams={selectedTeams}
      selectedTeamSection={selectedTeamSection}
      showPlayoffPicture={showPlayoffPicture}
    />
  </SportsStandingsContext.Provider>

}

/**
 * thie is the main page for LeagueStandings
 */
export default LeagueStandings